import { useExperiments } from '@backmarket/nuxt-module-experiments/useExperiments'

import { useSwapEnabled } from '../useSwapEnabled/useSwapEnabled'

export function useSaveTradeInInCart() {
  const { isSwapEnabled } = useSwapEnabled()
  const experiments = useExperiments()

  const isSaveTradeInInCartEnabled =
    isSwapEnabled && experiments['experiment.saveTradeInInCart'] === 'with'

  return { isSaveTradeInInCartEnabled }
}
